<template>
    <footer class="footer-section text-white mt-5" id="contacto">
        <div class="container">

            <!-- Logo -->
            <div class="text-center mb-4">
                <img src="@/assets/images/logo_principal.png"
                    width="140" alt="Logo El Terreno Gym" class="footer-logo" />
            </div>

            <div class="row justify-content-center mt-4">

                <div
                    class="col-12 col-md-8 d-flex flex-column flex-md-row justify-content-between text-center text-md-start">

                    <!-- Redes -->
                    <div class="mb-4">
                        <h5 class="footer-title">REDES SOCIALES</h5>

                        <div class="d-flex justify-content-center justify-content-md-start gap-4 mt-3">
                            <a class="footer-icon" href="https://www.facebook.com/profile.php?id=100063960199044"
                                aria-label="Facebook">
                                <i class="bi bi-facebook"></i> El Terreno Gym
                            </a>
                            <a class="footer-icon" href="https://www.instagram.com/crossfit_gym_box_el_terreno/"
                                aria-label="Instagram">
                                <i class="bi bi-instagram"></i> El Terreno Gym
                            </a>
                        </div>
                    </div>

                    <!-- Contacto -->
                    <div class="mb-4">
                        <h5 class="footer-title">Contacto</h5>

                        <div
                            class="d-flex justify-content-center justify-content-md-start align-items-center gap-2 mt-3">
                            <i class="bi bi-telephone" style="font-size: 1.8rem;"></i>
                            <span class="footer-text">554 086 1907</span>
                        </div>
                    </div>

                </div>
            </div>

            <hr class="footer-divider" />

            <p class="text-center footer-copy">
                &copy; 2026 El Terreno Gym CrossFit. Todos los derechos reservados.
            </p>
        </div>
    </footer>
</template>

<style scoped>
@font-face {
    font-family: 'FjallaOne';
    src: url('@/assets/fonts/FjallaOne-Regular.ttf') format('truetype');
    font-weight: normal;
}

.footer-section {
    font-family: 'FjallaOne';
    background-color: #1B1E20;
    padding: 50px 0 30px;
}

.footer-logo {
    filter: drop-shadow(0 0 6px rgba(255,255,255,0.2));
}

.footer-title {
    font-size: 1.1rem;
    letter-spacing: 1px;
    font-weight: 600;
    text-transform: uppercase;
    text-align: center;
}

.footer-icon {
  display: inline-flex;     /* mantiene en línea pero con flex */
  align-items: center;      /* alinea verticalmente */
  justify-content: center;  /* centra horizontalmente */
  gap: 8px;                 /* espacio entre ícono y texto */
  color: white;
  text-decoration: none;
}

.footer-icon i {
    font-size: 2rem;
    color: #ffffff;
    transition: 0.3s ease;
}

.footer-icon:hover i {
    color: #ffffff;
    font-size: 2rem;
}

.footer-contact-icon {
    font-size: 1.8rem;
    color: #DEEFA8;
}

.footer-text {
    font-size: 1.1rem;
}

.footer-divider {
    border-color: rgba(255,255,255,0.15);
    margin: 25px 0;
}

.footer-copy {
    font-size: 0.9rem;
    opacity: 0.8;
}

a {
    text-decoration: none;
    color: white;
    text-align: center;
}
</style>
